<template>
  <MainDesktop :navbar-items>
    <template #navbar-after>
      <AdvisorDesktopClientsPanel />
    </template>
    <template #content="{ isTabsVisible }">
      <MainDesktopTabs v-if="isTabsVisible" :parent :items />
    </template>
  </MainDesktop>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'

import { ROUTE_NAME } from '@/const'

import { useLocale } from '@/plugins/i18n'

import AdvisorDesktopClientsPanel from './AdvisorDesktopClientsPanel.vue'
import MainDesktop from './Desktop/Desktop.vue'
import MainDesktopTabs from './Desktop/Tabs/Tabs.vue'
import { ChartPieIcon } from '@heroicons/vue/24/outline'

const route = useRoute()

const { t } = useLocale('layouts.Main')

const navbarItems = computed(() => [
  {
    label: t('Dashboards'),
    icon: ChartPieIcon,
    route: ROUTE_NAME.ADVISOR,
    active: route.name === ROUTE_NAME.ADVISOR,
  },
])

const parent = computed(() => ({
  label: t('Dashboards'),
  icon: ChartPieIcon,
  route: ROUTE_NAME.ADVISOR,
  active: route.name === ROUTE_NAME.ADVISOR,
}))

const items = computed(() => [
  {
    label: 'Analytics',
    route: ROUTE_NAME.ADVISOR,
    active: true,
  },
])
</script>
